import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
	TEmVatReportsStore,
	TEmVatReportsListRequest,
	TEmVatReportsListResponse,
	TDownloadEmVatReportRequest,
} from './types';

export const initialState: TEmVatReportsStore = {
	emVatReportsList: null,
	emVatReportsListLoading: false,
	emVatReportDownloadLoading: false,
};

const emVatReports = createSlice({
	name: '@@emVatReports',
	initialState,
	reducers: {
		getEmVatReportsListRequest: (
			state: TEmVatReportsStore,
			_action: PayloadAction<TEmVatReportsListRequest>,
		) => {
			const emVatReportsState = state;
			emVatReportsState.emVatReportsListLoading = true;
		},
		getEmVatReportsListSuccess: (
			state: TEmVatReportsStore,
			action: PayloadAction<TEmVatReportsListResponse>,
		) => {
			const { payload } = action;
			const emVatReportsState = state;
			emVatReportsState.emVatReportsList = payload;
			emVatReportsState.emVatReportsListLoading = false;
		},

		downloadEmVatReportRequest: (
			state: TEmVatReportsStore,
			_action: PayloadAction<TDownloadEmVatReportRequest>,
		) => {
			const emVatReportsState = state;
			emVatReportsState.emVatReportDownloadLoading = true;
		},
		downloadEmVatReportFinally: (state: TEmVatReportsStore) => {
			const emVatReportsState = state;
			emVatReportsState.emVatReportDownloadLoading = false;
		},

		emVatReportsInitState: () => initialState,
	},
});

export default emVatReports.reducer;
export const {
	getEmVatReportsListRequest,
	getEmVatReportsListSuccess,
	downloadEmVatReportRequest,
	downloadEmVatReportFinally,
	emVatReportsInitState,
} = emVatReports.actions;
